export default {
  setLatestUploads: 'setLatestUploads',
  setNewCases: 'setNewCases',
};
